import { render, staticRenderFns } from "./PlayerRegistrationFormPaymentDetails.vue?vue&type=template&id=75be6a68&scoped=true&"
import script from "./PlayerRegistrationFormPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationFormPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be6a68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VForm,VIcon})
